import { Chains, VaultList, } from "../../constants/constants";
import { assetFilterList, getChainByAsset } from "../../utils/asset";
export var ProductList = [
    "yield",
    "volatility",
    "principalProtection",
    "capitalAccumulation",
];
export var VaultStrategyList = [
    "COVERED-CALL",
    "PUT-SELLING",
    "PRINCIPAL-PROTECTED",
];
export var VaultSortByList = [
    "SORT BY",
    "NEWEST FIRST",
    "OLDEST FIRST",
    "YIELD: HIGH TO LOW",
    "YIELD: LOW TO HIGH",
];
export var VaultSortByFilterOptions = VaultSortByList.map(function (item) {
    return item === VaultSortByList[0]
        ? {
            display: "DEFAULT",
            value: item,
        }
        : item;
});
export var VaultReleaseOrder = VaultList;
export var getFilterAssets = function (chain) {
    if (chain === Chains.NotSelected) {
        return assetFilterList;
    }
    return assetFilterList.filter(function (asset) { return getChainByAsset(asset) === chain; });
};
//# sourceMappingURL=types.js.map